import { render, staticRenderFns } from "./Electronpop2.vue?vue&type=template&id=da3f04b4&scoped=true"
import script from "./Electronpop2.vue?vue&type=script&lang=js"
export * from "./Electronpop2.vue?vue&type=script&lang=js"
import style0 from "./Electronpop2.vue?vue&type=style&index=0&id=da3f04b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3f04b4",
  null
  
)

export default component.exports